export const tableDataItem1 = [{
        prop: "lncRNA_id",
        label: "lncRNA ID",
        width: 160
    },
    // {
    //     prop: "ref_genome_version",
    //     label: "Ref Genome Version",
    //     width: 190
    // },
    {
        prop: "chr",
        label: "Chromosome",
        width: 130
    },
    {
        prop: "start",
        label: "Start",
        width: 90
    },
    {
        prop: "end",
        label: "End",
        width: 90
    },
    {
        prop: "strand",
        label: "Strand",
        width: 80
    },
    {
        prop: "species",
        label: "Species"
    },
    {
        prop: "source",
        label: "Source",
        width: 100
    }
]

export const tableDataItem3 = [{
        //     prop: "hits",
        //     label: "Hits"
        // },
        // {
        //     prop: "sbjct",
        //     label: "Subject"
        // },
        prop: "query_id",
        label: "Query"
    },
    {
        prop: "hits",
        label: "Subject"
    },
    {
        prop: "sbjct_start",
        label: "Subject start"
    },
    {
        prop: "sbjct_end",
        label: "Subject end"
    },
    {
        prop: "score",
        label: "Score"
    },
    {
        prop: "strand",
        label: "Strand"
    },
    {
        prop: "align_length",
        label: "Align length"
    },
    {
        prop: "identities",
        label: "Identities"
    }
    // {
    //     prop: "evalue",
    //     label: "evalue"
    // }
]
export const tableDataItem1_gene = [{
        prop: 'gene_id',
        label: 'Gene Locus'
    },
    {
        prop: 'isoform_id',
        label: 'Gene Model',
        width: 130
    },
    {
        prop: 'ref_genome_vers',
        label: 'Ref Genome Version'
    },
    {
        prop: 'chromesome_scaffold',
        label: 'Chromosome',
        width: 130
    },
    {
        prop: 'start',
        label: 'Start',
        width: 120
    },
    {
        prop: 'end',
        label: 'End',
        width: 120
    },
    {
        prop: 'strand',
        label: 'Strand',
        width: 120
    },
    {
        prop: 'species',
        label: 'Species'
    }
]